{
  "clear": "Cancella",
  "invalid": "(non valido)",
  "loading": "Caricamento in corso...",
  "noResults": "Nessun risultato"
}
